import React from "react";
import { useNavigate } from "react-router-dom";
import { Check } from "lucide-react";
import "./stepper.css";

type CampaignStepperProps = {
  currentStep: 1 | 2 | 3;
  campaignId?: string | number;
};

const CampaignStepper: React.FC<CampaignStepperProps> = ({
  currentStep,
  campaignId,
}) => {
  const navigate = useNavigate();

  const steps = [
    { step: 1, label: "Upload", path: "/audience" },
    {
      step: 2,
      label: "Strategy",
      path: campaignId ? `/campaign-strategy/${campaignId}` : undefined,
    },
    {
      step: 3,
      label: "Review & Launch",
      path: campaignId ? `/campaign-review/${campaignId}` : undefined,
    },
  ] as const;

  return (
    <div className="stepper">
      {steps.map((s, index) => {
        const isComplete = s.step < currentStep;
        const isCurrent = s.step === currentStep;
        const isClickable = !!s.path && s.step <= currentStep && !isCurrent;

        const statusClass = isComplete
          ? "is-complete"
          : isCurrent
          ? "is-current"
          : "is-upcoming";

        return (
          <React.Fragment key={s.step}>
            <button
              type="button"
              disabled={!isClickable}
              onClick={() => isClickable && s.path && navigate(s.path)}
              className={`stepper-step ${statusClass} ${
                isClickable ? "is-clickable" : "is-disabled"
              }`}
            >
              <span className="stepper-circle">
                {isComplete ? <Check size={15} /> : s.step}
              </span>
              <span className="stepper-label">{s.label}</span>
            </button>

            {index < steps.length - 1 && (
              <span
                className={`stepper-connector ${
                  s.step < currentStep ? "is-complete" : ""
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};

export default CampaignStepper;
